<script>
    import RecursiveFolderTree from './RecursiveFolderTree.svelte';
    import * as m from "@app/paraglide/messages.js";
    let {
        folders = [],
        expandedFolders = new Set(),
        isActiveFolder = () => false,
        toggleFolder = () => {},
        navigateToFolder = () => {},
        handleKeyDown = () => {},
        handleDragOver = () => {},
        handleDragLeave = () => {},
        handleDrop = () => {},
        isDropTargetValid = () => true
    } = $props();
</script>

{#each folders as folder}
    <li class="list-group-item border-0" role="none">
        <div class="d-flex align-items-center">
            <button 
                class="btn btn-sm btn-link p-0 me-1" 
                onclick={() => toggleFolder(folder.id)}
                onkeydown={(e) => handleKeyDown(e, () => toggleFolder(folder.id))}
                aria-label="{expandedFolders.has(folder.id) ? m.explorer_tree_collapse_label() : m.explorer_tree_expand_label()} {folder.name}">
                <i class="bi {expandedFolders.has(folder.id) ? 'bi-caret-down-fill' : 'bi-caret-right'} small" 
                    aria-hidden="true"></i>
            </button>
            <button 
                class="folder-name {isActiveFolder(folder) ? 'active-folder' : ''} btn btn-link p-0 text-start" 
                onclick={() => navigateToFolder(folder.id, folder)}
                onkeydown={(e) => handleKeyDown(e, () => navigateToFolder(folder.id, folder))}
                ondragover={(e) => handleDragOver(e, folder)}
                ondragleave={handleDragLeave}
                ondrop={(e) => handleDrop(e, folder)}
                data-folder-id={folder.id}
                data-folder-rootdir={folder.rootDir}
                role="treeitem" 
                aria-selected="{isActiveFolder(folder)}"
                aria-expanded="{expandedFolders.has(folder.id)}">
                <i class="bi bi-folder me-1" aria-hidden="true"></i> {folder.name}
            </button>
        </div>
        
        {#if expandedFolders.has(folder.id) && folder.children && folder.children.length > 0}
            <ul class="list-group border-0 ms-3 mt-1 folders-container" role="group">
                <RecursiveFolderTree 
                    folders={folder.children} 
                    {expandedFolders}
                    {isActiveFolder}
                    {toggleFolder}
                    {navigateToFolder}
                    {handleKeyDown}
                    {handleDragOver}
                    {handleDragLeave}
                    {handleDrop}
                    {isDropTargetValid}
                />
            </ul>
        {/if}
    </li>
{/each}

<style>
    .folders-container {
        min-width: max-content; /* Prevent text wrapping in folders */
    }
    
    .list-group-item {
        padding: 0.5rem 0.25rem;
        background: transparent;
    }
    
    .folder-name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex-grow: 1;
    }
</style>
